import { OnlineStatus } from '../../../../shared/friends/FriendTypes.ts';
import { UIRoomFriendListController } from '../../../shared/scripts/ui_html/room/UIRoomFriendListController.ts';
import { UIMMobileBottomDrawer } from './UIMMobileBottomDrawer.ts';
export class UIMInviteFriendsBottomDrawer extends UIMMobileBottomDrawer {
    static updateFriendList(friends) {
        this.friendList = friends;
        if (!this.friendListController) return;
        this.friendListController.updateFriendsList(friends);
    }
    static updateFriendOnlineStatus(friendData) {
        const friendIndex = this.friendList.findIndex((friend)=>friend.userId === friendData.userId);
        if (friendIndex < 0) this.friendList.push(friendData);
        else this.friendList[friendIndex] = friendData;
        this.friendList = this.friendList.filter((friend)=>friend.onlineStatus != OnlineStatus.Offline);
        if (!this.friendListController) return;
        this.friendListController.updateFriendsList(this.friendList);
    }
    static updateRoomState(roomState) {
        this.roomState = roomState;
        if (!this.friendListController) return;
        this.friendListController.updateRoomState(roomState);
    }
    constructor(){
        super({
            key: 'strings:roomPage.inviteFriends'
        });
        UIMInviteFriendsBottomDrawer.friendListController = new UIRoomFriendListController(this.content, this.title, this.content);
        UIMInviteFriendsBottomDrawer.friendListController.updateFriendsList(UIMInviteFriendsBottomDrawer.friendList);
        if (UIMInviteFriendsBottomDrawer.roomState) UIMInviteFriendsBottomDrawer.friendListController.updateRoomState(UIMInviteFriendsBottomDrawer.roomState);
    }
}
UIMInviteFriendsBottomDrawer.friendList = [];
